export default {
  data() {
    return {
      snack: false,
      snackText: '',
      snackColor: 'green',
      snakTimeOut: 5000,
      snakIcon: 'mdi-check-circle',
    };
  },
};
